












import { MensagemProntaService } from "@/services/mensagem-pronta.service";
import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";

interface ComboItem {
  text: string;
  value?: string;
}

@Component
export default class ComboMensagemPronta extends Vue {
  @Prop() readonly value!: string | null;
  @Prop({ default: () => [] }) readonly rules!: Array<(v: any) => string | undefined>;
  loading = false;
  mensagemPronta: ComboItem | null = null;
  itemsMensagemPronta: ComboItem[] = [];

  @Watch("value", { immediate: true })
  onValueChange(val: string | null) {
    val = '' + val;
    this.mensagemPronta = this.itemsMensagemPronta.find((x) => x.value == val) ?? null;
  }

  @Watch("mensagemPronta")
  onChangeTipo(val: ComboItem) {
    this.$emit("input", val?.value);
  }

  async fetchMensagemPronta() {
    this.loading = true;
    const res = await MensagemProntaService.obterMensagemPronta();
    this.itemsMensagemPronta = res.map((x) => ({
      text: x.tituloMensagem,
      value: "" + x.idMensagemPronta,
    }));

    if (this.value) {
      this.mensagemPronta = this.itemsMensagemPronta.find((x) => x.value == this.value) || null;
    }

    this.loading = false;
  }

  mounted() {
    this.fetchMensagemPronta();
  }
}
